import { render, staticRenderFns } from "./OrderItemsContainer.vue?vue&type=template&id=4199e43a&scoped=true&"
import script from "./OrderItemsContainer.vue?vue&type=script&lang=js&"
export * from "./OrderItemsContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4199e43a",
  null
  
)

export default component.exports